import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV_ITEMS = [
  { label: "Solutions", href: "#services", testId: "nav-link-solutions" },
  { label: "The Method", href: "#method", testId: "nav-link-method" },
  { label: "The Advisor", href: "#about", testId: "nav-link-about" },
  { label: "FAQ", href: "#faq", testId: "nav-link-faq" },
  { label: "Book a call", href: "#contact", testId: "nav-link-book" },
];

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = (href) => (e) => {
    e.preventDefault();
    setOpen(false);
    scrollTo(href);
  };

  return (
    <div
      className="fixed top-4 md:top-5 left-1/2 -translate-x-1/2 z-50 w-[94%] max-w-5xl"
      data-testid="pill-navbar"
    >
      <nav
        className={`rounded-full pl-4 pr-2 py-2 flex items-center justify-between gap-6 backdrop-blur-xl border transition-[background-color,box-shadow,border-color] duration-500 ${
          scrolled
            ? "bg-white/85 border-[#E6E2D8] shadow-[0_10px_30px_-12px_rgba(11,31,63,0.18)]"
            : "bg-white/60 border-transparent"
        }`}
        data-testid="site-header"
      >
        <a
          href="#top"
          onClick={handleNavClick("#top")}
          className="flex items-center gap-2.5 shrink-0"
          data-testid="nav-logo"
        >
          <img
            src="/prospera-icon.png"
            alt=""
            aria-hidden
            className="h-8 w-8 rounded-full object-cover"
            draggable={false}
          />
          <span className="font-display text-[#0B1F3F] text-[18px] tracking-tight">
            Prospera
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-8">
          {NAV_ITEMS.map((item) => (
            <li key={item.testId}>
              <a
                href={item.href}
                onClick={handleNavClick(item.href)}
                className="text-[13.5px] text-[#5A6476] hover:text-[#0B1F3F] transition-colors"
                data-testid={item.testId}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <Link
          to="/assessment"
          className="hidden md:inline-flex items-center px-5 py-2.5 rounded-full text-[13px] font-semibold text-white bg-[#0B1F3F] hover:bg-[#16305C] transition-colors shrink-0"
          data-testid="nav-cta-book-consultation"
        >
          Start assessment
        </Link>

        <button
          className="md:hidden h-10 w-10 rounded-full flex items-center justify-center text-[#0B1F3F] bg-[#F1EEE6]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle navigation"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={17} /> : <Menu size={17} />}
        </button>
      </nav>

      {open && (
        <div
          className="md:hidden mt-3 rounded-3xl border border-[#E6E2D8] bg-white/95 backdrop-blur-xl px-6 py-6 shadow-[0_20px_50px_-20px_rgba(11,31,63,0.25)]"
          data-testid="nav-mobile-menu"
        >
          <ul className="flex flex-col gap-4">
            {NAV_ITEMS.map((item) => (
              <li key={item.testId}>
                <a
                  href={item.href}
                  onClick={handleNavClick(item.href)}
                  className="text-[#0B1F3F] text-lg font-display"
                  data-testid={`${item.testId}-mobile`}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
          <Link
            to="/assessment"
            className="btn-primary mt-6 w-full"
            data-testid="nav-cta-book-consultation-mobile"
          >
            Start assessment
          </Link>
        </div>
      )}
    </div>
  );
}
